import React from "react";
import { Input, Button, Checkbox, message } from "antd";
import PropTypes from "prop-types";
import { FormattedMessage, injectIntl } from "react-intl";
import Portlet from "./portlet";
import { Svg } from "./Svg";

import "./list.css";

const ButtonGroup = Button.Group;

class ListItem extends React.Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    selected: PropTypes.bool
  };

  state = {
    mode: "show"
  };

  onClick = () => {
    this.props.onClick(this.props.data);
  };

  onEditStart = () => {
    this.setState({ mode: "edit" });
  };

  onEditCancel = () => {
    this.setState({ mode: "show" });
  };

  onEditComplete = () => {
    let data = Object.assign({}, this.props.data);
    data.title = this.input.input.value;
    this.props.onEdit(data);
    this.setState({ mode: "show" });
  };

  onDelete = () => {
    this.props.onDelete(this.props.data);
  };

  onCheck = () => {
    this.props.onCheck(this.props.data);
  };

  componentDidUpdate() {
    this.input && this.input.focus();
  }

  render() {
    const { selected, checked, data, formatMessage } = this.props;
    let className = "list-item";
    if (selected) {
      className += " selected";
    }
    if (this.state.mode === "edit") {
      className += " edit-mode";
      return (
        <li className={className}>
          <Input
            ref={input => (this.input = input)}
            onPressEnter={this.onEditComplete}
            size="small"
            placeholder={formatMessage({
              id: "list.inputPlaceholder",
              defaultMessage: "title"
            })}
            defaultValue={data.title}
            addonAfter={
              <ButtonGroup size="small">
                <Button
                  type="primary"
                  onClick={this.onEditComplete}
                  icon="check"
                />
                <Button onClick={this.onEditCancel} icon="close" />
              </ButtonGroup>
            }
          />
        </li>
      );
    } else {
      let deleteConfirmation = this.props.deleteConfirmation || (
        <span>
          <FormattedMessage
            id="list.delete-confirm"
            defaultMessage={"Are you sure? Delete item "}
          />
          "{data.title}"
        </span>
      );
      return (
        <li className={`${className} ${checked ? "checked" : ""}`}>
          <div className="item-title" onClick={this.onClick}>
            <span>{data.title.slice(0, 35)}</span>
            <Button type="primary" onClick={this.onEditStart}>
              <Svg id="edit" />
            </Button>
          </div>
          <Checkbox onClick={this.onCheck} checked={checked} />
        </li>
      );
    }
  }
}

export class AddItem extends React.Component {
  onAddStart = () => {
    this.props.onToggle();
  };

  onAddCancel = () => {
    this.props.onToggle();
  };

  onAddComplete = () => {
    this.props.onToggle();
    if (this.props.onAdd) this.props.onAdd({ title: this.input.input.value });
    else
      message.error(
        this.props.formatMessage({
          id: "list.noProjects",
          defaultMessage:
            "To add a new form, please select the Project for which this form is intended"
        })
      );
  };

  componentDidUpdate() {
    this.input && this.input.focus();
  }

  render() {
    const { formatMessage } = this.props;
    if (this.props.isEdit) {
      return (
        <div className="list-item add edit-mode">
          <Input
            ref={input => (this.input = input)}
            onPressEnter={this.onAddComplete}
            size="small"
            placeholder={formatMessage({
              id: "list.inputPlaceholder",
              defaultMessage: "title"
            })}
            addonAfter={
              <ButtonGroup size="small">
                <Button
                  type="primary"
                  onClick={this.onAddComplete}
                  icon="check"
                />
                <Button onClick={this.onAddCancel} icon="close" />
              </ButtonGroup>
            }
          />
        </div>
      );
    } else {
      return (
        <div className="list-item add" onClick={this.onAddStart}>
          <Button size="small" className="add-btn">
            <FormattedMessage
              id={`list.add.${this.props.isProject ? "project" : "offer"}`}
              defaultMessage="Add"
            />
          </Button>
        </div>
      );
    }
  }
}

export class List extends React.Component {
  static propTypes = {
    data: PropTypes.array.isRequired,
    onSelect: PropTypes.func.isRequired,
    onEditItem: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
    checkAll: PropTypes.func.isRequired,
    onCheck: PropTypes.func.isRequired,
    deleteItemConfirmation: PropTypes.string,
    selected: PropTypes.object,
    header: PropTypes.node,
    item: PropTypes.node,
    addItem: PropTypes.node,
    checkedList: PropTypes.array,
    isProject: PropTypes.bool.isRequired
  };

  state = {
    isToggled: false
  };

  onToggle = () => {
    this.setState(({ isToggled }) => ({ isToggled: !isToggled }));
  };

  render() {
    const {
      header,
      data = [],
      item,
      addItem,
      deleteItemConfirmation,
      selected,
      onSelect,
      onEditItem,
      onDelete,
      onAddItem,
      onCheck,
      checkedList = [],
      checkAll,
      isProject
    } = this.props;
    const ItemComponent = item || ListItem;
    const AddComponent = addItem || AddItem;
    return (
      <Portlet
        className="list"
        header={header}
        onCheck={checkAll}
        checked={checkedList.length === data.length && data.length !== 0}
        isDisabledDel={!checkedList.length}
        onToggle={this.onToggle}
        list={checkedList}
        onDelete={onDelete}
        isProject={isProject}
      >
        <ul>
          {data.map(item => (
            <ItemComponent
              key={item.id}
              data={item}
              onClick={onSelect}
              onEdit={onEditItem}
              onCheck={onCheck}
              checked={!!~checkedList.indexOf(item.id)}
              deleteConfirmation={deleteItemConfirmation}
              selected={selected && item.id === selected.id}
              formatMessage={this.props.intl.formatMessage}
            />
          ))}
        </ul>
        <AddComponent
          onAdd={onAddItem}
          isEdit={this.state.isToggled}
          onToggle={this.onToggle}
          isProject={isProject}
          formatMessage={this.props.intl.formatMessage}
        />
      </Portlet>
    );
  }
}

export default injectIntl(List);


// WEBPACK FOOTER //
// ./src/components/utils/list.js